import { Card, Text } from '@mercai/clever'

import { CardMetricProps } from './card-metric.type'

import styles from './card-metric.module.css'

export const CardMetric = ({ information, title }: CardMetricProps) => {
  return (
    <Card className={styles.card}>
      <div className={styles.header}>
        <div>
          <Text variant="text-small">{title}</Text>
        </div>
      </div>
      <Text variant="text-medium">{information}</Text>
    </Card>
  )
}
